


























import TheMenu from "../components/TheMenu.vue";
import ThePageHeader from "../components/ThePageHeader.vue";
import { Component } from "vue-property-decorator";
import Vue from "vue";
import { Func } from "mocha";
import { State, Action, Getter } from "vuex-class";

@Component({ components: { TheMenu, ThePageHeader } })
export default class AppLayout extends Vue {

}
